module.exports = __webpack_public_path__ + "static/logo-coveteur@2x-d40c4a22fe2f5f6eb26340fa5f85105d.png";